import styled from 'styled-components';

const MyInfoImg = styled.img`
    height: 40px;
`;

export default MyInfoImg;